import { z } from "zod/v4"

/**
 * Category type schema based on swagger.json
 */
export const categoryTypeSchema = z.union([
  z.literal("INCOME"),
  z.literal("EXPENSE"),
])

export type TCategoryType = z.infer<typeof categoryTypeSchema>

/**
 * Account schema based on swagger.json GET /finances/accounts
 */
export const accountSchema = z.object({
  id: z.string(),
  name: z.string(),
})

export type TAccount = z.infer<typeof accountSchema>

/**
 * Category schema based on swagger.json GET /finances/categories
 */
export const categorySchema = z.object({
  id: z.string(),
  name: z.string(),
  type: categoryTypeSchema,
  isActive: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export type TCategory = z.infer<typeof categorySchema>

/**
 * Account form schema for create
 */
export const accountFormSchema = z.object({
  name: z.string().min(1, "Nome é obrigatório"),
  organizationSlug: z.string(),
  // Optional initial balance - creates initial INCOME transaction on account creation
  initialBalance: z
    .union([
      z.number(),
      z
        .string()
        .transform((val) => Number(val.replace(/\D+/g, "")))
        .pipe(z.number()),
    ])
    .optional(),
})

export type TAccountForm = z.infer<typeof accountFormSchema>

/**
 * Category form schema for create
 */
export const categoryFormSchema = z.object({
  name: z.string().min(1, "Nome é obrigatório"),
  type: categoryTypeSchema,
  organizationSlug: z.string(),
})

export type TCategoryForm = z.infer<typeof categoryFormSchema>

/**
 * Create account response
 */
export const createAccountResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
})

export type TCreateAccountResponse = z.infer<typeof createAccountResponseSchema>

/**
 * Create category response
 */
export const createCategoryResponseSchema = categorySchema

export type TCreateCategoryResponse = z.infer<
  typeof createCategoryResponseSchema
>

/**
 * List accounts response
 */
export const listAccountsResponseSchema = z.array(accountSchema)

export type TListAccountsResponse = z.infer<typeof listAccountsResponseSchema>

/**
 * List categories response
 */
export const listCategoriesResponseSchema = z.array(categorySchema)

export type TListCategoriesResponse = z.infer<
  typeof listCategoriesResponseSchema
>
